export const SET_LOADING = 'ajax/SET_LOADING';
